"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bcp_1 = require("@iov/bcp");
const crypto_1 = require("@iov/crypto");
const encoding_1 = require("@iov/encoding");
const long_1 = __importDefault(require("long"));
const constants_1 = require("./constants");
class Derivation {
    static isValidAddress(address) {
        const ending = constants_1.constants.addressSuffix;
        const tail = address.slice(-ending.length);
        if (tail !== ending) {
            return false;
        }
        const addressString = address.slice(0, -ending.length);
        // parse as unsigned base 10 number and verify re-encoding matches encoding
        // this is no leading zeros, no decimals, within 0 <= addressString <= 2**64-1
        const addressNumber = long_1.default.fromString(addressString, true, 10); // true => unsigned
        return addressNumber.toString(10) === addressString;
    }
    static pubkeyToAddress(pubkey) {
        if (pubkey.algo !== bcp_1.Algorithm.Ed25519 || pubkey.data.length !== 32) {
            throw new Error("Not a valid ed25519 public key");
        }
        const suffix = constants_1.constants.addressSuffix;
        // https://github.com/prolina-foundation/snapshot-validator/blob/35621c7/src/lisk.cpp#L26
        const hash = new crypto_1.Sha256(pubkey.data).digest();
        const firstEightBytes = Array.from(hash.slice(0, 8));
        const addressString = long_1.default.fromBytesLE(firstEightBytes, true).toString(10) + suffix;
        return addressString;
    }
    static async passphraseToKeypair(passphrase) {
        const encodedPassphrase = encoding_1.toUtf8(passphrase);
        const hash = new crypto_1.Sha256(encodedPassphrase).digest();
        const keypair = await crypto_1.Ed25519.makeKeypair(hash);
        return keypair;
    }
}
exports.Derivation = Derivation;
//# sourceMappingURL=derivation.js.map